







































import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Unsubscribe extends Vue {
  get id () {
    return this.$route.query?.leadListId as string
  }

  get subscribed () {
    return this.$store.getters.subscribed
  }

  async created () {
    this.$store.dispatch('getSubscribtionInfo', this.id)
  }

  unsubsribe () {
    this.$router.push({ name: 'Unsubscribe', query: { leadListId: this.id } })
  }
}
